import React from "react";
import BaseModal from "../../components/BaseModal";
import ClonedOrderList from "../../components/orders/ClonedOrdersList";

const ImportOrderModal = ({ visible, onCancel, data, history, handleEditOrder }) => {
  const handleRedirect = (clonedOrderId) => {
    if (history && clonedOrderId) {
      onCancel();
      history.push(`/orders/${clonedOrderId}/details?open_import_modal=true`);
    }
  };

  const listData = Array.isArray(data) ? data : (data ? [data] : []);

  return (
    <BaseModal
      title="Import Order Created"
      visible={visible}
      onCancel={onCancel}
      width="550px"
      footer={null}
      destroyOnClose
    >
      <ClonedOrderList
        data={listData}
        pagination={{ position: "none" }}
        handleEditOrder={handleEditOrder || handleRedirect}
        importLabel={{ source: "Bonded Order", cloned: "Imported Order" }}
      />
    </BaseModal>
  );
};

export default ImportOrderModal;
